import React, { useEffect, useState } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";

import FbIconImg from "../assets/images/provider/facebook.png";
import InstaIconImg from "../assets/images/provider/instagram.png";
import logo from "../assets/images/mmplay.png";
import AppuGames from "../assets/images/provider/Betfair.jpg";
import EvolutionGames from "../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../assets/images/provider/provider-logo-ezugi.png";

import Amazonpay from "../assets/images/payments/new/Amazonpay.webp";
import HDFC from "../assets/images/payments/new/HDFC.webp";
import AxisBank from "../assets/images/payments/new/Axis_Bank_logo.webp";
import SBI from "../assets/images/payments/new/SBI-Logo.webp";
import Phonepay from "../assets/images/payments/new/phonepe.webp";
import Paytm from "../assets/images/payments/new/Paytm.webp";
import GooglaPay from "../assets/images/payments/new/google-pay-tez-logo-CFC8957086-seeklogo.com.webp";
import UPIcon from "../assets/images/payments/new/UPI.webp";
import IcIcIcbank from "../assets/images/payments/new/ICICI_Bank_Logo.webp"
import YesBank from "../assets/images/payments/new/Yes_Bank_SVG_Logo.webp"
import Visa from "../assets/images/payments/new/visa.webp"
import mastercard from "../assets/images/payments/new/master.webp";
import astropay from "../assets/images/payments/new/astropay.webp"

import Calling1 from "../assets/images/icons/phone.png";
import Whatapps from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/telegram.png";
import Mail from "../assets/images/icons/mail.png";

import WhatsaPPImg from "../assets/images/icons/whatsappfoot.png";
import TelegramImg from "../assets/images/icons/telegramfoot.png";

import IPhone from "../assets/images/icons/apple.png";
import AndroidIcon from "../assets/images/icons/android-character-symbol.png";
import SocialIcon from "../assets/images/icons/energy.png";
import AppIcon from "../assets/images/icons/download.png";
import BottomNav from "./BottomNav";

const Footer = () => {
  const { appDetails } = useSelector((state) => state.app);

  return (
    <>
      <footer className="footer">
        <Container>
          <div className="footer-logo">
            <a href="#" className="footerImg">
              <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
              <div className="logodivider"></div>
            </a>
          </div>
          <div className="sectionDivide">
            <div className="social-icons">
              <h3>
                <img src={SocialIcon} alt="Social" />
                Social Network
              </h3>
              <ul>
                <li className="telegram">
                  <a
                    href={
                      appDetails?.TELEGRAM != ""
                        ? appDetails?.TELEGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={TelegramImg} />
                  </a>
                </li>
                <li className="whatsapp">
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={WhatsaPPImg} />
                  </a>
                </li>
                <li className="instagram">
                  <a
                    href={
                      appDetails?.INSTATGRAM != ""
                        ? appDetails?.INSTATGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                  >
                    <img src={InstaIconImg} />
                  </a>
                </li>
                <li className="facebook">
                  <a
                    href={
                      appDetails?.FACEBOOK != ""
                        ? appDetails?.FACEBOOK
                        : "javascript:void(0)"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={FbIconImg} />
                  </a>
                </li>
              </ul>
            </div>
            <div className="androidSection">
              <h3>
                <img src={AppIcon} alt="Social" /> App Download
              </h3>
              <div className="APKSection">
               
                <a
                  href="https://dl.dropbox.com/scl/fi/yriug139tbo0lw0hgjwfl/Betshera.apk?rlkey=vbghlpxreclzx6bai6nliwn5i&st=8gzo0sco&dl=0"
                  download="https://dl.dropbox.com/scl/fi/yriug139tbo0lw0hgjwfl/Betshera.apk?rlkey=vbghlpxreclzx6bai6nliwn5i&st=8gzo0sco&dl=0"
                  className="android"
                >
                  <img src={AndroidIcon} alt="iphone icon" />
                  <p>
                    Download for <br />
                    <b>Android</b>
                  </p>
                </a>
              </div>
            </div>
          </div>

          <div className="HomeContent">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <h1>
                    Betshera – Your Trusted Platform for Online Cricket
                    ID, Sports Betting & Casino Games in India
                  </h1>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="HomePageInnerContent">
                    <p>
                      Step into the world of Betshera, where Indian
                      players enjoy a fast, secure, and rewarding
                      experience in online cricket betting, real-time
                      sports wagers, and thrilling online casino games.
                      Whether you're a beginner looking for your first
                      cricket betting ID or an experienced punter
                      seeking a reliable online betting exchange,
                      Betshera has everything you need—all in one place.
                    </p>
                    <p>
                      With a user-friendly interface and localized
                      support, Betshera is designed specifically for
                      Indian players who love sports like cricket,
                      football, and kabaddi.
                    </p>
                    <h2>Our platform offers:</h2>
                    <ul>
                      <li>Live betting options with real-time odds</li>
                      <li>
                        Secure and fast payments via UPI, Paytm, Net
                        Banking, and crypto
                      </li>
                      <li>
                        Attractive bonuses including a 5% deposit bonus
                        and 10% losing bonus
                      </li>
                      <li>
                        Instant access to popular cricket events like
                        IPL, World Cup, and Test matches
                      </li>
                      <li>
                        A complete online casino with slots, roulette,
                        Andar Bahar, Teen Patti & more
                      </li>
                    </ul>
                    <p>
                      At Betshera, you're not just placing bets—you're
                      entering a world where skill, timing, and
                      opportunity meet. With transparent policies,
                      responsible gaming tools, and round-the-clock
                      support, we’re building a trustworthy environment
                      for every sports enthusiast and casino lover in
                      India.
                    </p>
                    <h2>Why Thousands of Players Choose Betshera?</h2>
                    <p>
                      Betshera isn't just another betting site. It’s a
                      community of winners. Here’s why more and more
                      users are joining every day:
                    </p>
                    <ul>
                      <li>
                        <b>Instant Cricket ID Creation --</b>Sign up in
                        30 seconds using just your phone number.
                      </li>
                      <li>
                        <b>India-First Experience --</b> Full support
                        for UPI, Paytm, PhonePe, and other local payment
                        methods.
                      </li>
                      <li>
                        <b>No KYC Required --</b> Skip lengthy paperwork
                        and start playing immediately.
                      </li>
                      <li>
                        <b>Mobile-Friendly Platform --</b> Optimized for
                        Android & iOS users. No need to download any
                        app.
                      </li>
                      <li>
                        <b>Daily & Weekly Bonuses --</b> Get rewarded
                        every time you deposit or play.
                      </li>
                      <li>
                        <b>Transparent Rules & Fast Withdrawals --</b>
                        What you win is what you keep.
                      </li>
                    </ul>
                    <h2>Live Cricket Betting on Betshera</h2>
                    <p>
                      Betshera brings you a real-time cricket betting
                      experience that’s second to none. With in-depth
                      odds, fast updates, and multiple markets, you can
                      place informed bets with confidence on:
                    </p>
                    <ul>
                      <li>Indian Premier League (IPL)</li>
                      <li>T20 World Cup</li>
                      <li>India vs Pakistan</li>
                      <li>Test Matches & One Day Internationals</li>
                      <li>Big Bash League, BPL, PSL & more</li>
                    </ul>
                    <p>
                      Enjoy both pre-match and live match betting. Use
                      back and lay betting options just like a
                      professional exchange. Follow each ball, run,
                      over, and wicket with real-time statistics and
                      dynamic odds.
                    </p>
                    <p>
                      Whether you’re betting on “Who will win the toss?”
                      or “Total runs in an over,” Betshera has markets
                      for every cricket fan.
                    </p>
                    <h2>Online Casino Games at Betshera</h2>
                    <p>
                      If you're looking for high-quality online casino
                      action, Betshera has it all! Play top-rated games
                      for real cash:
                    </p>
                    <ul>
                      <li>
                        Slot Machines – Try your luck on jackpots,
                        themes, and fast-paced reels.
                      </li>
                      <li>
                        Teen Patti & Andar Bahar – Classic Indian card
                        games, now online with live dealers.
                      </li>
                      <li>
                        Live Casino – Roulette, Blackjack, Baccarat,
                        Poker, and more with real-time video.
                      </li>
                      <li>
                        Crash Games & Aviator – High-risk, high-reward
                        games for adrenaline lovers.
                      </li>
                    </ul>
                    <p>
                      All games are powered by certified software
                      providers and work seamlessly across mobile and
                      desktop. You can deposit anytime and start playing
                      instantly.
                    </p>
                    <h2>
                      How to Start Betting on Betshera – Step-by-Step
                    </h2>
                    <p>
                      Getting started is easy, even for beginners.
                      Here's how:
                    </p>
                    <ul className="nobullets">
                      <li>
                        <div>1. Visit Betshera.com</div>
                        <p>Open the site on your mobile or desktop.</p>
                      </li>
                      <li>
                        <div>2. Register with Mobile Number</div>
                        <p>
                          No KYC needed. Get your online cricket betting
                          ID in seconds.
                        </p>
                      </li>
                      <li>
                        <div>3. Deposit Money</div>
                        <p>
                          Use UPI, Paytm, Google Pay, PhonePe, or bank
                          transfer. Instant top-up supported.
                        </p>
                      </li>
                      <li>
                        <div>4. Claim Bonuses Automatically</div>
                        <p>
                          Every deposit comes with a 5% bonus. If you
                          lose, get 10% back next day.
                        </p>
                      </li>
                      <li>
                        <div>5. Start Playing</div>
                        <p>
                          Choose cricket, casino, slots, or live table
                          games. Place your bet and enjoy!
                        </p>
                      </li>
                      <li>
                        <div>6. Withdraw Instantly</div>
                        <p>
                          Cash out anytime with fast processing and zero
                          hidden charges.
                        </p>
                      </li>
                    </ul>
                    <h1>FAQs</h1>
                    <h2>
                      1. Is Betshera legal and safe to use in India?
                    </h2>
                    <p>
                      Yes, Betshera is a secure and legally compliant
                      platform for online betting and casino gaming in
                      India. While India does not have centralized laws
                      for online betting, it allows international
                      platforms like Betshera that operate outside the
                      country but accept Indian players. We ensure your
                      betting experience is not only fun but also fully
                      safe.
                    </p>
                    <p>
                      Our platform uses advanced SSL encryption to
                      protect your personal and financial data. We also
                      support trusted Indian payment methods like UPI,
                      Paytm, and PhonePe, so all transactions remain
                      secure.
                    </p>
                    <p>
                      With no KYC needed and fast withdrawals, Betshera
                      has become a go-to option for thousands of Indian
                      users who want to bet on sports or enjoy online
                      casinos safely from their mobile or desktop.
                    </p>
                    <h2>
                      2. How do I create a cricket betting ID on
                      Betshera?
                    </h2>
                    <p>
                      Creating your betting ID with Betshera is simple
                      and takes less than 30 seconds. Here's how:
                    </p>
                    <ul className="nobullets">
                      <li>
                        1. Visit{" "}
                        <a href="www.betshera.com">www.betshera.com</a>
                      </li>
                      <li>
                        2. Click on the Register or Join Now button.
                      </li>
                      <li>
                        3. Enter your mobile number and verify it via
                        OTP.
                      </li>
                      <li>4. Set a secure password.</li>
                      <li>
                        5. That’s it – your cricket betting ID is ready!
                      </li>
                    </ul>
                    <p>
                      You don’t need to upload any documents or go
                      through complicated KYC processes. As soon as you
                      register, you’ll be able to deposit money, claim
                      bonuses, and start betting right away.
                    </p>
                    <p>
                      If you ever lose access to your account, you can
                      recover it instantly using your registered mobile
                      number.
                    </p>
                    <h2>3. What bonuses can I claim at Betshera?</h2>
                    <p>
                      At Betshera, we reward every player from Day 1
                      with exciting bonuses that help you play more and
                      win more:
                    </p>
                    <ul>
                      <li>
                        <div>
                          <b>5% Bonus on Every Deposit</b>
                          <p>
                            Every time you deposit money, you’ll get an
                            automatic 5% bonus added to your account. No
                            need to use a promo code or coupon.
                          </p>
                        </div>
                      </li>
                      <li>
                        <div>
                          <b>10% Losing Bonus (Cashback)</b>
                          <p>
                            Lost your bets? Don’t worry — you’ll receive
                            10% of your net losses back the next day as
                            cashback. This keeps your game going and
                            gives you another shot to win.
                          </p>
                        </div>
                      </li>
                      <li>
                        <div>
                          <b>
                            Special Promotions for IPL, India vs
                            Pakistan & Festivals
                          </b>
                          <p>
                            Watch out for match-specific or festival
                            offers — including extra deposit matches,
                            free spins, and lucky draws.
                          </p>
                        </div>
                      </li>
                    </ul>
                    <p>
                      All bonuses are easy to claim and transparent.
                      Terms are clearly explained, and there’s no hidden
                      condition or complex rollover like other sites.
                    </p>
                    <h2>
                      4. What sports and games can I bet on with
                      Betshera?
                    </h2>
                    <p>
                      Betshera is built for Indian users who love
                      real-money betting and gaming. Here’s what you can
                      enjoy:
                    </p>
                    <p>
                      <b>Sports Betting:</b>
                    </p>
                    <ul>
                      <li>
                        Cricket (IPL, T20, ODI, World Cup, BBL, PSL,
                        etc.)
                      </li>
                      <li>
                        Football (Premier League, ISL, La Liga,
                        Champions League)
                      </li>
                      <li>Basketball</li>
                      <li>Tennis</li>
                      <li>Kabaddi & more</li>
                    </ul>
                    <p>
                      We also offer Live Exchange betting with back &
                      lay options for advanced users.
                    </p>
                    <p>
                      <b>Casino Games:</b>
                    </p>
                    <ul>
                      <li>Teen Patti, Andar Bahar (Live Dealers)</li>
                      <li>Blackjack, Baccarat, Poker</li>
                      <li>
                        Slot Games (Jackpot Slots, Themed Reels,
                        Megaways)
                      </li>
                      <li>Aviator, Crash, JetX & Instant Win Games</li>
                      <li>Roulette (European, American, Auto)</li>
                    </ul>
                    <p>
                      All games work on both mobile and desktop and are
                      available 24/7.
                    </p>

                    <h2>
                      5. How do I deposit money into my Betshera
                      account?
                    </h2>
                    <p>
                      Depositing money into your Betshera wallet is easy
                      and secure. We support all popular Indian payment
                      methods:
                    </p>
                    <ul>
                      <li>UPI (Google Pay, PhonePe, Paytm, BHIM)</li>
                      <li>Net Banking</li>
                      <li>Bank Transfer</li>
                    </ul>
                    <p>Minimum deposit: 100</p>
                    <p>
                      Deposits are instant, and you’ll get your 5%
                      deposit bonus automatically after payment.
                    </p>
                    <p>
                      We never charge hidden fees on deposits, and your
                      money is safe through encrypted gateways. In case
                      your transaction fails, our support team is always
                      ready to help via WhatsApp or Telegram.
                    </p>
                    <h2>
                      6. How can I withdraw my winnings from Betshera?
                    </h2>
                    <p>
                      Withdrawing your winnings is fast, smooth, and
                      transparent. Follow these steps:
                    </p>
                    <ul className="nobullets">
                      <li>1. Go to your Wallet or Account section.</li>
                      <li>2. Enter your desired withdrawal amount.</li>
                      <li>
                        3. Choose a withdrawal method – UPI or Bank
                        Transfer.
                      </li>
                      <li>4. Click Submit</li>
                    </ul>
                    <p>Minimum withdrawal: 500</p>
                    <p>
                      Processing time: Usually under 30 minutes (max 2
                      hours)
                    </p>
                    <p>
                      There are no unnecessary limits or paperwork
                      required. Unlike other platforms that delay or
                      reject withdrawals, Betshera makes sure you get
                      your money on time – every time.
                    </p>
                    <p>
                      You can withdraw your real balance anytime, even
                      if you’ve used bonuses — once bonus conditions are
                      met (if any).
                    </p>

                    <h2>
                      7. Do I need to complete KYC to start betting on
                      Betshera?
                    </h2>
                    <p>
                      No, Betshera does not require KYC to register or
                      start playing.
                    </p>
                    <p>
                      That means you can sign up with just your mobile
                      number and start betting instantly.
                    </p>
                    <p>
                      You only need to complete minimal verification if
                      you're making very large transactions or if
                      required by the payment gateway for fraud
                      protection. For most users, especially new
                      players, no documents are ever asked.
                    </p>
                    <p>
                      This KYC-free registration is one of the reasons
                      Betshera is the go-to platform for thousands of
                      Indian users who want fast, anonymous, and secure
                      betting.
                    </p>
                    <h2>8. Can I use Betshera on my mobile phone?</h2>
                    <p>
                      Absolutely. Betshera is designed to work smoothly
                      on all mobile devices. You don’t need to download
                      an app — just open www.betshera.com in your mobile
                      browser.
                    </p>
                    <ul>
                      <li>Fully optimized for Android and iOS</li>
                      <li>Easy navigation with tap-friendly design</li>
                      <li>Fast page loading even on slow internet</li>
                      <li>
                        Play all games – slots, live casino, sports –
                        directly on your phone
                      </li>
                    </ul>
                    <p>
                      Whether you're betting from home or on the go,
                      your mobile experience will be just as fast and
                      seamless as desktop.
                    </p>

                    <h2>
                      9. What is back & lay betting, and does Betshera
                      support it?
                    </h2>
                    <p>
                      Yes, Betshera supports Back & Lay betting,
                      especially for cricket and football lovers who use
                      the Betting Exchange.
                    </p>
                    <ul>
                      <li>
                        Back Bet: You’re betting for something to happen
                        (e.g., Team A will win).
                      </li>
                      <li>
                        Lay Bet: You’re betting against something (e.g.,
                        Team A will NOT win).
                      </li>
                    </ul>
                    <p>
                      This gives you more control and flexibility over
                      your bets — you can lock profits, cut losses, or
                      hedge your risks during a live match.
                    </p>
                    <p>
                      It’s a professional way to bet and widely used in
                      markets like cricket exchange. If you’re a serious
                      bettor, you’ll love our Exchange interface — with
                      dynamic odds and live trading options.
                    </p>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>


          <div className="footerSection">
            <h3>Betshera Policies</h3>
            <div className="footer-links">
              <ul>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                  <li>
                    <a href="/privacypolicy">Privacy Policy</a>
                  </li>

                  <li>
                    <a href="/ResponsibleGaming">Responsible Gaming</a>
                  </li>
                  <li>
                    <a href="/fairplay">Fair Play</a>
                  </li>
                  <li>
                    <a href="/gamerules">Games Rules</a>
                  </li>
                  <li>
                    <a href="/termsandcondition">Terms and Conditions</a>
                  </li>
              </ul>
            </div>
          </div>

          <div className="paymentspartner">
            <ul>
              <li>
                <img src={UPIcon} />
              </li>
              <li>
                <img src={Phonepay} />
              </li>
              <li>
                <img src={Paytm} />
              </li>
              <li>
                <img src={Amazonpay} />
              </li>
              <li>
                <img src={GooglaPay} />
              </li>
              <li>
                <img src={HDFC} />
              </li>
              <li>
                <img src={AxisBank} />
              </li>
              <li>
                <img src={SBI} />
              </li>
              <li>
                <img src={IcIcIcbank} />
              </li>
              <li>
                <img src={YesBank} />
              </li>
              <li>
                <img src={Visa} />
              </li>
              <li>
                <img src={mastercard} />
              </li>
              <li>
                <img src={astropay} />
              </li>
            </ul>
          </div>

          <div className="copyright">
            <p>Copyright © 2026 Betshera. All rights reserved</p>
          </div>
          
        </Container>

        

        <BottomNav />
      </footer>
    </>
  );
};

export default Footer;
